import { createSlice } from '@reduxjs/toolkit'

const widget = createSlice({
    name: 'widget',//Данные для виджетов 
    initialState: {
        list: []  //Список виджетов        
    },
    reducers: {
        load(state, action) {
            state.list = action.payload.list;
        },
        favotiteSet(state, action) {
            const id_widget = action.payload.id_widget;
            const val = action.payload.val;

            state.list = state.list.map((item) => {
                if (item.ID === id_widget) {
                    return { ...item, Favorite: val }
                }
                else {
                    return { ...item }
                }
            })
        }
    }
})

export const { load, favotiteSet } = widget.actions
export default widget.reducer